import { render, staticRenderFns } from "./CardTransactionHistoryV2.vue?vue&type=template&id=2fd5c18c&scoped=true&"
import script from "./CardTransactionHistoryV2.vue?vue&type=script&lang=js&"
export * from "./CardTransactionHistoryV2.vue?vue&type=script&lang=js&"
import style0 from "./CardTransactionHistoryV2.vue?vue&type=style&index=0&id=2fd5c18c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5c18c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VImg,VRow})
